import React from "react";
import { graphql } from "gatsby";
import { SanitySlice, SEO } from "@ottomotors/ottomotors.com/components";
import { AnchorLinks } from "@ottomotors/ottomotors.com/slices";
import { IOttoMotorsWebinar } from "@ottomotors/ottomotors-sanity";

import * as styles from "./styles.module.scss";

interface IProps {
  data: {
    sanityOttomotorsWebinar: IOttoMotorsWebinar;
  };
}

const Webinar = ({ data: staticData }: IProps) => {
  const { sanityOttomotorsWebinar } = staticData;
  const {
    title,
    resourceTopics,
    publishedDate,
    pagebuilder,
    seo,
    hasAnchorLinks,
    sideAnchorLinks
  } = sanityOttomotorsWebinar || {};

  if (!pagebuilder?.slices?.[0]) {
    return null;
  }

  const pageMetadata = {
    heading: seo?.title || title,
    description: seo?.description,
    topics: resourceTopics?.topics,
    publishedDate: publishedDate,
  };

  return (
    <div className={styles.container}>
      {hasAnchorLinks && <AnchorLinks data={{ slices: pagebuilder.slices, side: sideAnchorLinks }} />}

      {pagebuilder.slices.map((slice: any) => (
        <div key={slice._key}>
          <SanitySlice
            key={slice._key}
            data={slice}
            pageMetadata={pageMetadata}
          />
        </div>
      ))}
    </div>
  );
};

export default Webinar;

export const query = graphql`
  query Webinar($id: String!) {
    sanityOttomotorsWebinar(id: { eq: $id }) {
      title
      slug {
        current
      }
      hasAnchorLinks
      sideAnchorLinks
      streamUrl
      publishedDate
      resourceTopics {
        topics
      }

      pagebuilder {
        ...OttomotorsPagebuilderFragment
      }

      seo {
        ...SeoFragment
      }
      _type
    }
  }
`;

export const Head = ({ data: { sanityOttomotorsWebinar } }: IProps) => {
  const {
    slug: { current: slug },
    title,
    seo,
    _type,
  } = sanityOttomotorsWebinar;

  const pathname = slug === `/` ? `/` : `/${slug}/`;

  const seoTitle = seo?.title || title;

  return (
    <SEO
      pageTitle={seoTitle}
      pageType={_type}
      pathname={pathname}
      description={seo?.description}
      keywords={seo?.keywords}
      openGraphImageUrl={seo?.image?.asset?.url}
      noIndex={seo?.noIndex}
    />
  );
};
